export class TimeoutManager {
    private _timerId: number;

    private _onTimeExpired: () => void;

    constructor(onTimeExpired: () => void) {
        this._onTimeExpired = onTimeExpired;
    }

    public restart(secondDuration: number): void {
        this.stop();
        this.startTimer(secondDuration);
    }

    public stop(): void {
        clearTimeout(this._timerId);
    }

    private startTimer(secondDuration: number): void {
        this._timerId = setTimeout(() => this.timeoutExpired(), secondDuration * 1000);
    }

    private timeoutExpired(): void {
        this.stop();

        if (this._onTimeExpired) {
            this._onTimeExpired();
        }
    }
}
